import type { UseQueryResult } from '@tanstack/react-query';
import type { ReactNode } from 'react';

import type { ApiFailureError } from '../../../lib/http/errors';
import type { Breakdown, BreakdownMetric, Overview } from '../api/schemas';
import { InfluenceMap } from './InfluenceMap';
import { OverviewBody } from './layout';
import { MetricsGrid } from './MetricsGrid';
import { MovementCard } from './MovementCard';
import { TerritoryCard } from './RankedCards';
import type { Span } from './figures';

export function OverviewView(props: {
  reading: Overview;
  span: Span;
  campaignId: string;
  breakdown: UseQueryResult<Breakdown, ApiFailureError>;
  dimensionId: string | null;
  onDimensionChange: (dimensionId: string) => void;
  metric: BreakdownMetric;
  onMetricChange: (metric: BreakdownMetric) => void;
}): ReactNode {
  const { reading } = props;
  return (
    <div className="flex flex-col gap-4">
      <MetricsGrid reading={reading} />
      <OverviewBody
        main={
          <>
            <MovementCard movement={reading.movement} span={props.span} />
            <InfluenceMap
              campaignId={props.campaignId}
              breakdown={props.breakdown}
              dimensionId={props.dimensionId}
              onDimensionChange={props.onDimensionChange}
              metric={props.metric}
              onMetricChange={props.onMetricChange}
            />
          </>
        }
        side={<TerritoryCard campaignId={props.campaignId} territory={reading.territory} />}
      />
    </div>
  );
}
